var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('Headers'),_c('Layout',{staticClass:"layout_conten"},[_c('img',{staticClass:"layout_bg",attrs:{"src":require("@/assets/image/bg.png")}}),_c('div',{staticClass:"layout_main"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }